import React from 'react';

function UploadTest() {
  return <div>UploadTest</div>;
}

export default UploadTest;
